module.exports = __webpack_public_path__ + "img/RoomService.bf907520.svg";